import { useState } from "react";

import {
  SettingsDomain,
  SettingsDomainApiResponse,
  useSettingsDomain,
} from "./domainSettings";

export interface TimeSettings {
  timezone: string;
  data?: SettingsDomainApiResponse<SettingsDomain>;
  fromServer: boolean;
}

const defaultTimeSettings: TimeSettings = {
  timezone: "Europe/Dublin",
  fromServer: false,
};

let latestTimeSettings = defaultTimeSettings;

export const useTimeSettings = (suspense?: boolean): TimeSettings => {
  const [timeSettings, setTimeSettings] = useState(latestTimeSettings);

  const { data } = useSettingsDomain({
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    suspense: suspense ?? latestTimeSettings === defaultTimeSettings,
  });

  if (data) {
    const domainTimezone = data.data.time.timezone;

    const timezone = domainTimezone.split(" ")[1];

    const hasTimezone = timezone != null && timezone !== "";

    if (
      hasTimezone &&
      (timezone !== timeSettings.timezone || timeSettings.data == null)
    ) {
      const newTimeSettings = {
        timezone,
        data,
        fromServer: true,
      };

      latestTimeSettings = newTimeSettings;
      setTimeSettings(newTimeSettings);
    }
  }

  return timeSettings;
};
